const isDebugLoggingEnabled = process.env.NODE_ENV !== "production";

const debugLog = (...args: unknown[]): void => {
  if (!isDebugLoggingEnabled) {
    return;
  }

  console.info(...args);
};

export default debugLog;